export enum JobDocumentFilterStates {
  dontHave = 0,
  have = 1,
  notInFilter = 2,
}
